import { render, staticRenderFns } from "./CreateClientPage.vue?vue&type=template&id=0133b416"
import script from "./CreateClientPage.vue?vue&type=script&lang=js"
export * from "./CreateClientPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports